import { render, staticRenderFns } from "./PriceRoomSpecialUpdate.vue?vue&type=template&id=bc1b82ba"
import script from "./PriceRoomSpecialUpdate.vue?vue&type=script&lang=js"
export * from "./PriceRoomSpecialUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports